import React from 'react';
import { createRoot } from 'react-dom/client';
import { loadGoogleMaps } from './app/services/googleMapsLoader';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';

/**
 * Après un déploiement, un onglet resté ouvert peut encore référencer d'anciens
 * chunks JS (supprimés du serveur par le déploiement suivant). Vite émet
 * `vite:preloadError` quand un import dynamique échoue pour cette raison :
 * on recharge la page une seule fois pour récupérer la dernière version.
 */
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  const reloadKey = 'app-stale-chunk-reload';
  if (window.sessionStorage.getItem(reloadKey)) {
    return;
  }
  window.sessionStorage.setItem(reloadKey, '1');
  window.location.reload();
});

loadGoogleMaps();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

createRoot(container).render(
  <Router
    future={{
      v7_relativeSplatPath: true,
    }}
  >
    <App />
  </Router>,
);

window.sessionStorage.removeItem('app-stale-chunk-reload');

reportWebVitals();
